import moment from 'moment'
import 'antd/dist/antd.css'
import { Checkbox, DatePicker } from 'antd';

interface customDateRangeProps {
    backStartDate:any
    setBackStartDate:any
    backEndDate:any
    setBackEndDate:any
}


const { RangePicker } = DatePicker;

const CustomDateRange:React.FC<customDateRangeProps> = ({setBackStartDate,setBackEndDate,backStartDate,backEndDate}) => {
    const handleDateChange = (values: any) => {
        if (!values) {
            return;
        }
        setBackStartDate(moment(values[0])?.format('YYYY-MM-DD'));
        setBackEndDate(moment(values[1])?.format('YYYY-MM-DD'));
        let startDate: any = moment(values[0]).format('YYYY-MM-DD');
        let endDate: any = moment(values[1]).format('YYYY-MM-DD');
    }

    const selectionRange:any = {
        startDate: moment().startOf('week').toDate(),
        endDate: moment().startOf('week').toDate()
    }

    return(
        <>
            <RangePicker
                format="DD MMM YYYY"
                className='range_pick_calende_chart'
                defaultValue= {[moment(backStartDate), moment(backEndDate)]}
                onChange={(values: any) => {
                    handleDateChange(values)
                }}
                disabledDate={(current: any) => {
                    let customDate = moment().format("YYYY-MM-DD");
                    return (
                        current == moment(customDate, "YYYY-MM-DD")
                    );
                }}
            />
        </>
    )
}

export default CustomDateRange;


